require("!!/usr/app/node_modules/script-loader/addScript.js")(require("!!/usr/app/node_modules/raw-loader/index.js!/usr/app/node_modules/jquery.scrollto/jquery.scrollTo.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery.scrollto/jquery.scrollTo.min.js
// module id = 33
// module chunks = 2 5